/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit TagStatusShortButton/view.blocks to change it.
import "DesignSystem/Fonts/Inter-400.css"
import "DesignSystem/Fonts/Inter-600.css"
import Children from 'Simple/Children'
import React from 'react'
import TysiaText from 'DesignSystem/TysiaText/index'
import styles from './view.module.css'
import useIsHovered from 'Simple/hooks/useIsHovered'



/** @type {import('Simple/types.js').View} */
export default function TagStatusShortButton({
  children,
  viewPath = "/DesignSystem/TagStatusShortButton",
  marginLeft = 0,
  marginRight = 0,
  marginTop = 0,
  width = 24,
  height = 24,
  paddingLeft = 0,
  paddingRight = 0,
  onClick,
  isSelected,
  text,
  fontSize = 12
  
}) {
let [isHovered, isSelectedHovered, isHoveredBind] = useIsHovered({isSelected})
  return (<React.Fragment
>
<button
  data-testid="TagStatusShortButton.Horizontal"
  data-view-path={viewPath}
 {...isHoveredBind}
 onClick={onClick}
 style={{'--ml-2-Z1jIlWz': typeof marginLeft === 'number' ? `${marginLeft}px` : marginLeft,'--mr-3-Z1jIlWz': typeof marginRight === 'number' ? `${marginRight}px` : marginRight,'--mt-4-Z1jIlWz': typeof marginTop === 'number' ? `${marginTop}px` : marginTop,'--w-5-Z1jIlWz': typeof width === 'number' ? `${width}px` : width,'--h-6-Z1jIlWz': typeof height === 'number' ? `${height}px` : height,'--pl-7-Z1jIlWz': typeof paddingLeft === 'number' ? `${paddingLeft}px` : paddingLeft,'--pr-8-Z1jIlWz': typeof paddingRight === 'number' ? `${paddingRight}px` : paddingRight,'--bc-1-Z1jIlWz': isSelected ? "rgba(0,188,112, 0.1)" : isHovered ? "rgba(111,111,111, 0.1)" : "rgba(0,188,112,0)",'--bc-9-Z1jIlWz': isSelected ? "rgba(0,188,112, 0.8)" : "rgba(0,188,112, 0)"}}
 className={`views-block ${styles.Horizontal}`}
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 text={text}
 marginTop={2}
 color={isSelected ? "rgb(0,150,89)" : "#474747"}
 fontFamily="Inter"
 fontSize={fontSize}
 fontWeight={600}
/>
<Children
  viewPath={`${viewPath}/Children`}
 isSelected={isSelected} isHovered={isHovered} isSelectedHovered={isSelectedHovered}
>
{children}
</Children>
</button>
</React.Fragment>)
}